export default "__VITE_ASSET__CQ_D2XQ8__"